// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SingleDatePicker_picker {\n  z-index: 20;\n}\n", "",{"version":3,"sources":["webpack://../../node_modules/@visma/formula/lib/configToSchemas/types/date/style.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb","sourcesContent":[".SingleDatePicker_picker {\n  z-index: 20;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
